<script setup>
import {definePage} from "unplugin-vue-router/runtime";

definePage({
  meta: {
    title: '404 - Page not found',
    requiresAuth: false,
  },
})
</script>

<template>
  <v-card
    class="ma-auto text-center mt-9 pa-5"
    max-width="500"
  >
    <v-card-title>
      <h4>404: Pagina niet gevonden</h4>
    </v-card-title>
    <v-card-text class="text-center mt-3">
      <v-btn
        class="font-weight-bold"
        style="letter-spacing: 0"
        color="secondary" variant="text"
        :to="'/'"
      >
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 320 512" height="14"
             style="font-weight: 900; line-height: 120%; font-size: 14px; margin-right: 6px">
          <path fill="rgb(76, 123, 242)"
            d="M9.4 233.4c-12.5 12.5-12.5 32.8 0 45.3l192 192c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L77.3 256 246.6 86.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0l-192 192z"
          />
        </svg>
        Terug
      </v-btn>
    </v-card-text>
  </v-card>
</template>
